import { createContext } from 'react';

const TransportsTableContext = createContext({});

export default TransportsTableContext;
